import { render } from "./InventoryItemDetailsMainCard.vue?vue&type=template&id=0958fb76&scoped=true"
import script from "./InventoryItemDetailsMainCard.vue?vue&type=script&lang=js"
export * from "./InventoryItemDetailsMainCard.vue?vue&type=script&lang=js"

import "./InventoryItemDetailsMainCard.vue?vue&type=style&index=0&id=0958fb76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0958fb76"]])

export default __exports__